import React from 'react';
import classnames from 'clsx';
import { FormattedMessage } from 'react-intl';
import { messages } from './messages';
import styles from './styles.module.css';

/**
 * @param {object} props
 * @param {string} [props.className]
 * @returns {JSX.Element}
 */
export const DangerousGoodsTag = ({ className = '' }) => {
  return (
    <div className={classnames(styles['dangerous-goods-tag'], className)}>
      <FormattedMessage {...messages.dangerousGoods} />
    </div>
  );
};
